import React from "react";
import { Spinner } from "react-bootstrap";

import { useSelector } from "react-redux";

import MappingWindow from "../mapping/MappingWindow";

const FieldMappings = () => {
  const {
    mappings: {
      defaultMappings: { productFields: mappings },
    },
    shopify: {
      shopifyDropdownFields: { productFields: shopifyFields },
      loading: shopifyLoading,
    },
    msbc: {
      msbcDropdownFields: { productFields: msbcFields },
      loading: msbcLoading,
    },
  } = useSelector((state) => state.mapping);

  return (
    <div>
      {shopifyLoading || msbcLoading ? (
        <div
          className="d-flex flex-row justify-content-center align-items-center my-3"
          style={{ height: "40vh" }}
        >
          <Spinner
            animation="border"
            variant="secondary"
            role="status"
            size="md"
          ></Spinner>
        </div>
      ) : (
        <div>
          {msbcFields &&
            msbcFields.length > 0 &&
            shopifyFields &&
            shopifyFields.length > 0 && (
              <MappingWindow
                mappings={mappings}
                msbcFields={msbcFields}
                shopifyFields={shopifyFields}
                mappingsFor="productFields"
                notificationPath="productFieldMappings"
                cmsPath="cmsContent.syncSettings.product.fieldMappings"
              />
            )}
        </div>
      )}
    </div>
  );
};

export default FieldMappings;
